export const clamp01 = (x) => Math.max(0, Math.min(1, x));

// Temporal crossfade curves (2001 -> 2026)
export const towerOpacity = (t) => clamp01(1 - (t - 2001) / 7);
export const wtcOpacity = (t) => clamp01((t - 2006) / 8);
export const poolFactor = (t) => clamp01((t - 2004) / 6);
export const sphereOpacity = (t) => clamp01(1 - (t - 2001) / 6);

export function fadeGroup(group, opacity) {
  if (!group) return;
  const vis = opacity > 0.01;
  group.visible = vis;
  if (!vis) return;
  group.traverse((o) => {
    if (o.isMesh && o.material) {
      const mats = Array.isArray(o.material) ? o.material : [o.material];
      mats.forEach((m) => {
        m.transparent = opacity < 0.995;
        m.opacity = opacity;
        m.depthWrite = opacity > 0.5;
      });
    }
  });
}
